import React from 'react';

const linksComponent = props => {
  return (
      <div className="section-wrapper z-depth-1 wow fadeIn" data-wow-delay="0.1s">
        <div className="col s12 m12 l10 website right">
          <div className="row">
            <div className="col s12 m12 l6">
              <span><a href="https://www.linkedin.com/in/nick-chiafullo-853562141/">LinkedIn</a></span>
            </div>
            <div className="col s12 m12 l6">
              <span><a href="http://www.scatterdev.com">Blog</a></span>
            </div>

            {/*<div className="col col s12 m12 l6">*/}
              {/*<span><a href="">www.dribble.com/rtralrayhan</a></span>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
  )
};

export default linksComponent;